var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white pa-12"},[_c('div',{staticClass:"text-center mb-4"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":200,"width":25,"color":"primary"}})],1),_c('h1',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('payment.successful-payment-info-create-billing'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }